import { toRegionalSpelling } from "./locale";
import type { RegionId } from "./regions";
import type { TciBand, TciBandId } from "./types";

const HIGHLY_OPTIMIZED: TciBand = {
  id: "highly-optimized",
  label: "Highly Optimized",
  min: 0,
  max: 15,
};

const STANDARD: TciBand = {
  id: "standard",
  label: "Standard Trapped Capacity",
  min: 16,
  max: 40,
};

const EFFICIENCY_GOLDMINE: TciBand = {
  id: "efficiency-goldmine",
  label: "Efficiency Goldmine",
  min: 41,
  max: 100,
};

export const TCI_BANDS: readonly TciBand[] = [
  HIGHLY_OPTIMIZED,
  STANDARD,
  EFFICIENCY_GOLDMINE,
];

/**
 * Map a TCI score (0–100) to a band.
 * Boundaries: 0–15, 16–40, 41–100.
 */
export function getTciBand(score: number): TciBand {
  if (score <= 15) {
    return HIGHLY_OPTIMIZED;
  }
  if (score <= 40) {
    return STANDARD;
  }
  return EFFICIENCY_GOLDMINE;
}

export function getTciBandId(score: number): TciBandId {
  return getTciBand(score).id;
}

/** Band with region-aware spelling on the display label. */
export function getLocalizedTciBand(
  score: number,
  regionId?: RegionId | null,
): TciBand {
  const band = getTciBand(score);
  return {
    ...band,
    label: toRegionalSpelling(band.label, regionId),
  };
}
